import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './GoogleMap.less';
import mapMarker from '../../../assets/images/map-marker.png';

const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
};

export const GoogleMap = (props) => {
    const [animated, setAnimated] = useState(false);
    const googleMapView = useRef();

    const {
        createGoogleMapViewTest,
        mapsApi,
        lat,
        lng
    } = props;

    const createGoogleMapView = () => {
        let marker;
        let googleMap;

        if (createGoogleMapViewTest) createGoogleMapViewTest(marker, googleMap);
        if (!mapsApi || Object.keys(mapsApi).length === 0) return;
        setAnimated(true);
        const position = { lat, lng };
        try {
            googleMap = new mapsApi.Map(
                googleMapView.current, {
                    zoom: 14,
                    center: position,
                    disableDefaultUI: true
                }
            );
            marker = new mapsApi.Marker({
                position,
                animation: mapsApi.Animation ? mapsApi.Animation.DROP : undefined,
                icon: mapMarker,
                map: googleMap
            });

            if (createGoogleMapViewTest) createGoogleMapViewTest(marker, googleMap);
        // eslint-disable-next-line no-empty
        } catch (e) { }
    };

    useDidMountEffect(() => {
        const isLocationSet = lat && lng;
        if (isLocationSet) {
            createGoogleMapView();
        }
    }, [lat, mapsApi, lng]);

    useEffect(() => {
        if (animated) {
            setTimeout(() => { setAnimated(false); }, 1000);
        }
    }, [animated]);

    const isLocationSet = lat && lng;
    const classes = classnames('google-map-view', { 'no-display': !isLocationSet, animated });

    return <div data-wdio="google-map-component" className={classes} ref={googleMapView} />;
};

GoogleMap.propTypes = {
    createGoogleMapViewTest: PropTypes.func,
    lat: PropTypes.number,
    lng: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    mapsApi: PropTypes.object
};

GoogleMap.defaultProps = {
    createGoogleMapViewTest: () => {},
    lat: null,
    lng: null,
    mapsApi: {}
};

export default GoogleMap;
